import { render, staticRenderFns } from "./paper_order_info.pug?vue&type=template&id=159feb2c&lang=pug&"
import script from "./paper_order_info.ts?vue&type=script&lang=ts&"
export * from "./paper_order_info.ts?vue&type=script&lang=ts&"
import style0 from "./paper_order_info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports